import Vue from 'vue'
import App from './App.vue'
import router from './router/index'



Vue.config.productionTip = false;
Vue.mixin({
  data: function(){
    return{
      get apiUrl(){
        return "https://api.woodblocker.gr/api";
      }
    }
  }
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
